<script setup>
import InformationTable from '../components/InformationTable.vue';
import {APIService} from '@/core/util/services/api.service';
import {onMounted, ref} from 'vue';
import Status from '../constants/Status';
import {numericOnly} from '@/core/util/validation/rules';

const employeesHttp = new APIService(
  window.appGlobal.baseUrl,
  'api/v2/pim/employees',
);

const owners = ref([]);

const rules = ref({
  code: [numericOnly],
});

onMounted(() => {
  employeesHttp
    .getAll({
      includeEmployees: 'onlyCurrent',
      limit: 0,
    })
    .then(response => {
      owners.value = response.data.data.map(employee => {
        return {
          id: employee.empNumber,
          label: `${employee.firstName} ${employee.middleName} ${employee.lastName}`,
        };
      });
    });
});
</script>
<template>
  <div class="orangehrm-background-container">
    <InformationTable>
      <template #default="{filters, onReset, onSubmit}">
        <oxd-table-filter filter-title="Informations List">
          <oxd-form @reset="onReset" @submitValid="onSubmit">
            <oxd-form-row>
              <oxd-grid :cols="3" class="orangehrm-full-width-grid">
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.code"
                    :rules="rules.code"
                    label="Code"
                    placeholder="Code"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.title"
                    label="Title"
                    placeholder="Title"
                  />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.owners"
                    label="Owner"
                    value="Select"
                    type="multiselect"
                    :options="owners"
                  />
                </oxd-grid-item>
              </oxd-grid>
              <oxd-grid :cols="3" class="orangehrm-full-width-grid">
                <oxd-grid-item>
                  <date-input v-model="filters.createdAt" label="Created At" />
                </oxd-grid-item>
                <oxd-grid-item>
                  <date-input v-model="filters.dueDate" label="Due Date" />
                </oxd-grid-item>
                <oxd-grid-item>
                  <oxd-input-field
                    v-model="filters.status"
                    label="Status"
                    value="Select"
                    type="select"
                    :options="Status"
                  />
                </oxd-grid-item>
              </oxd-grid>
            </oxd-form-row>

            <oxd-divider />

            <oxd-form-actions>
              <required-text />
              <oxd-button
                display-type="ghost"
                :label="$t('general.reset')"
                type="reset"
              />
              <oxd-button
                class="orangehrm-left-space"
                display-type="secondary"
                :label="$t('general.search')"
                type="submit"
              />
            </oxd-form-actions>
          </oxd-form>
        </oxd-table-filter>
      </template>
    </InformationTable>
  </div>
</template>
